module.exports = __webpack_public_path__ + "static/media/CloseSmallIcon.a93236d4.svg";